export default __webpack_public_path__ + "static/media/instagram.af1a671e.svg";